import React, { createContext } from 'react';

type LearningContextType = {
  setContentView: React.Dispatch<React.SetStateAction<Window>>;
};
export const LearningContext = createContext<LearningContextType>({
  setContentView: () => {},
});
